// import dynamically homepage if it matches;
import './index.scss';
import Glide from '@glidejs/glide';
import "../src/script/import-jquery";

import ('./rest');


loadLazySized();
loadGlide();
loadAdvertDetails();
loadChat();
loadChart();
loadCharts();
checkSurvey();
checkParams();

import ('../src/script/functions/general').then(_module => {
    _module.setupBoundaries()
});

const searchInput = document.querySelector('#search-form [name="search"]');
const AdvancedSearchButton = document.querySelector('.advanced-search');
if (searchInput || AdvancedSearchButton) {
    import ('../src/script/components/search').then(_module => {
        if (searchInput) {
            searchInput.addEventListener('focus', () => {
                initSearchSliders();
            })
        }
        if (AdvancedSearchButton) {
            AdvancedSearchButton.addEventListener('click', () => {
                initSearchAutocomplete(_module.initAutoComplete);
            })
        }
    });
}

function loadAdvertDetails() {
    const pageSegment = document.body.getAttribute('segment');
    if (pageSegment === 'adverts') {
        const slider = (function() {
            //const
            const slider = document.getElementById("slider");
            const sliderContent = document.querySelector(".slider-content");
            const sliderWrapper = document.querySelector(".slider-content-wrapper");
            const elements = document.querySelectorAll(".slider-content__item");
            const sliderContentControls = createHTMLElement("div", "slider-content__controls");
            let dotsWrapper = null;
            let prevButton = null;
            let nextButton = null;
            let autoButton = null;
            let leftArrow = null;
            let rightArrow = null;
            let intervalId = null;

            // data
            const itemsInfo = {
                offset: 0,
                position: {
                    current: 0,
                    min: 0,
                    max: elements.length - 1
                },
                intervalSpeed: 2000,
                update: function(value) {
                    this.position.current = value;
                    this.offset = value;
                },
                reset: function() {
                    this.position.current = 0;
                    this.offset = 0;
                }
            };

            const controlsInfo = {
                buttonsEnabled: false,
                dotsEnabled: false,
                prevButtonDisabled: true,
                nextButtonDisabled: false
            };

            function init(props) {
                let {
                    intervalSpeed,
                    position,
                    offset
                } = itemsInfo;

                if (slider && sliderContent && sliderWrapper && elements) {
                    if (props && props.intervalSpeed) {
                        intervalSpeed = props.intervalSpeed;
                    }
                    if (props && props.currentItem) {
                        if (parseInt(props.currentItem) >= position.min && parseInt(props.currentItem) <= position.max) {
                            position.current = props.currentItem;
                            offset = -props.currentItem;
                        }
                    }
                    if (props && props.buttons) {
                        controlsInfo.buttonsEnabled = true;
                    }
                    if (props && props.dots) {
                        controlsInfo.dotsEnabled = true;
                    }

                    _updateControlsInfo();
                    _createControls(controlsInfo.dotsEnabled, controlsInfo.buttonsEnabled);
                    _render();
                } else {
                    console.log("fdfds");
                }
            }

            function _updateControlsInfo() {
                const {
                    current,
                    min,
                    max
                } = itemsInfo.position;
                controlsInfo.prevButtonDisabled = current > min ? false : true;
                controlsInfo.nextButtonDisabled = current < max ? false : true;
            }

            function _createControls(dots = true, buttons = false) {

                sliderContent.append(sliderContentControls);

                createArrows();
                buttons ? createButtons() : null;
                dots ? createDots() : null;

                function createArrows() {
                    const dValueLeftArrow = "M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z";
                    const dValueRightArrow = "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z";
                    const leftArrowSVG = createSVG(dValueLeftArrow);
                    const rightArrowSVG = createSVG(dValueRightArrow);

                    leftArrow = createHTMLElement("div", "prev-arrow");
                    leftArrow.append(leftArrowSVG);
                    leftArrow.addEventListener("click", () => updateItemsInfo(itemsInfo.position.current - 1))

                    rightArrow = createHTMLElement("div", "next-arrow");
                    rightArrow.append(rightArrowSVG);
                    rightArrow.addEventListener("click", () => updateItemsInfo(itemsInfo.position.current + 1))

                    sliderContentControls.append(leftArrow, rightArrow);

                    // SVG function
                    function createSVG(dValue, color = "currentColor") {
                        const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                        svg.setAttribute("viewBox", "0 0 256 512");
                        const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
                        path.setAttribute("fill", color);
                        path.setAttribute("d", dValue);
                        svg.appendChild(path);
                        return svg;
                    }
                }

                // Dots function
                function createDots() {
                    dotsWrapper = createHTMLElement("div", "dots");
                    for (let i = 0; i < itemsInfo.position.max + 1; i++) {
                        const dot = document.createElement("div");
                        dot.className = "dot";
                        dot.addEventListener("click", function() {
                            updateItemsInfo(i);
                        })
                        dotsWrapper.append(dot);
                    }
                    sliderContentControls.append(dotsWrapper);
                }

                // Buttons function
                function createButtons() {
                    const controlsWrapper = createHTMLElement("div", "slider-controls");
                    // prevButton = createHTMLElement("button", "prev-control", "Prev");
                    // prevButton.addEventListener("click", () => updateItemsInfo(itemsInfo.position.current - 1))

                    // autoButton = createHTMLElement("button", "auto-control", "Auto");
                    // autoButton.addEventListener("click", () => {
                    // 	intervalId = setInterval(function(){
                    // 		if (itemsInfo.position.current < itemsInfo.position.max) {
                    // 			itemsInfo.update(itemsInfo.position.current + 1);
                    // 		} else {
                    // 			itemsInfo.reset();
                    // 		}
                    // 		_slideItem();
                    // 	}, itemsInfo.intervalSpeed)
                    // })

                    // nextButton = createHTMLElement("button", "next-control", "Next");
                    // nextButton.addEventListener("click", () => updateItemsInfo(itemsInfo.position.current + 1))

                    // controlsWrapper.append(prevButton, autoButton, nextButton);
                    // slider.append(controlsWrapper);
                }
            }

            function setClass(options) {
                if (options) {
                    options.forEach(({
                        element,
                        className,
                        disabled
                    }) => {
                        if (element) {
                            disabled ? element.classList.add(className) : element.classList.remove(className)
                        } else {
                            console.log("Error: function setClass(): element = ", element);
                        }
                    })
                }
            }

            function updateItemsInfo(value) {
                itemsInfo.update(value);
                _slideItem(true);
            }

            function _render() {
                const {
                    prevButtonDisabled,
                    nextButtonDisabled
                } = controlsInfo;
                let controlsArray = [{
                        element: leftArrow,
                        className: "d-none",
                        disabled: prevButtonDisabled
                    },
                    {
                        element: rightArrow,
                        className: "d-none",
                        disabled: nextButtonDisabled
                    }
                ];
                if (controlsInfo.buttonsEnabled) {
                    controlsArray = [
                        ...controlsArray,
                        {
                            element: prevButton,
                            className: "disabled",
                            disabled: prevButtonDisabled
                        },
                        {
                            element: nextButton,
                            className: "disabled",
                            disabled: nextButtonDisabled
                        }
                    ];
                }

                setClass(controlsArray);

                sliderWrapper.style.transform = `translateX(${itemsInfo.offset * 100}%)`;

                if (controlsInfo.dotsEnabled) {
                    if (document.querySelector(".dot--active")) {
                        document.querySelector(".dot--active").classList.remove("dot--active");
                    }
                    dotsWrapper.children[itemsInfo.position.current].classList.add("dot--active");
                }
            }

            function _slideItem(autoMode = false) {
                if (autoMode && intervalId) {
                    clearInterval(intervalId);
                }
                _updateControlsInfo();
                _render();
            }

            function createHTMLElement(tagName = "div", className, innerHTML) {
                const element = document.createElement(tagName);
                className ? element.className = className : null;
                innerHTML ? element.innerHTML = innerHTML : null;
                return element;
            }

            return {
                init
            };
        }())

        slider.init({
            currentItem: 0,
            buttons: true,
            dots: true
        });
    }
}

function loadGlide() {
    const glide = document.querySelector('.glide');
    if (glide) {
        new Glide('.glide', {
            type: 'carousel',
            perView: 5,
            focusAt: 'center',
            autoplay: 1000,
            hoverpause: false,
            breakpoints: {
                800: {
                    perView: 4
                },
                480: {
                    perView: 3
                }
            }
        }).mount()
        setTimeout(() => {
            glide.style.visibility = 'visible';
        }, 150)
    }
}

function loadLazySized() {
    let script = document.createElement("script");
    script.async = true;
    script.src = "https://cdnjs.cloudflare.com/ajax/libs/lazysizes/4.1.8/lazysizes.min.js";
    document.body.appendChild(script);
}

function InitSearchData(initAutoComplete) {

    const {
        data
    } = CATEGORIES;

    if (!data) {
        return;
    }

    initAutoComplete('.all-categories', 'input-autocom', null, {
        data: data,
        display: 'category_name',
        header: category => `<div class="sidebar-menu-item-link">
                    <img src="${category.image_path}" alt="${category.category_name}">
                    <h2>${category.category_name}</h2>
                </div>`,
        local: 'childs',
        minLength: 0
    });

    initAutoComplete('.autocomplete-cities', 'input-autocom', null, {
        data: {
            data: {
                'childs': CITIES_DATA
            }
        },
        display: 'city_name',
        header: city => ``,
        local: 'childs',
        minLength: 0
    });
}

function initSearchAutocomplete(initAutoComplete) {
    if (CATEGORIES.data.length > 0) {
        InitSearchData(initAutoComplete);
    } else {
        console.warn('warning code 01');
    }
}

function initSearchSliders() {
    const sliders = $('.search-sliders');
    if (sliders.length) {
        import ('../src/script/components/search-v2')
        .then(_module => {
                _module.initSearchV2();
            })
            .catch(err => {
                console.error(err);
            });
    }
}

function checkParams() {
    const currentUrl = new URL(window.location.href);
    const {
        searchParams
    } = currentUrl;

    if (searchParams.has('update-cv')) {
        const el = document.querySelector('.login-update-cv');
        el.style.display = 'block';
    }
}

function loadChart() {
    const ctx = document.querySelector('#myChart');
    if (ctx !== null) {
        import ('../src/script/chartjs/chart.min.js').then(Chart => {
            const chartTabs = document.querySelectorAll('.currency-charts-tabs .tab');
            var myChart = updateChart(loadChartData('usd'));
            chartTabs.forEach(tab => {
                tab.addEventListener('click', ev => {
                    const currencys = tab.getAttribute('currency');
                    // console.log('1', currencys);
                    myChart = updateChart(loadChartData(currencys), myChart);
                    chartTabs.forEach(tabItem => {
                        if (tab !== tabItem) {
                            tabItem.classList.remove('active');
                        }
                    })
                    tab.classList.add('active');
                })
            });

            function updateChart(data, chart) {
                if (data == null || !data) {
                    return;
                }
                const options = {
                    "type": "line",
                    "data": {
                        labels: data[0].category,
                        "datasets": data
                    },
                    options: {
                        scales: {
                            yAxes: [{
                                ticks: {
                                    stepSize: 50
                                }
                            }]
                        }
                    }
                }
                if (chart) {
                    // console.log('4')
                    chart.data.datasets = data;
                    chart.data.labels = data[0].category;
                    chart.update();
                    return chart;
                }
                return new Chart(ctx, options);
            }

            function loadChartData(currency) {
                // console.log('3', currency);
                if (currency === 'center_bank') {
                    return [{
                        "label": chartData.center_bank.label,
                        "data": chartData.center_bank.data,
                        "category": chartData.center_bank.category,
                        "fill": true,
                        "borderColor": "#99cc66",
                        "backgroundColor": "#4AA6DF55",
                        "lineTension": 0.1,
                    }];
                }
                if (currency === 'usd') {
                    return [{
                        "label": chartData.usd.label,
                        "data": chartData.usd.data,
                        "category": chartData.usd.category,
                        "fill": true,
                        "borderColor": "#99cc66",
                        "backgroundColor": "#4AA6DF55",
                        "lineTension": 0.1,
                    }];
                }
                if (currency === 'usd_alternate') {
                    return [{
                        "label": chartData.usd_alternate.label,
                        "data": chartData.usd_alternate.data,
                        "category": chartData.usd_alternate.category,
                        "fill": false,
                        "borderColor": "#99cc66",
                        "backgroundColor": "#99cc6655",
                        "lineTension": 0.1
                    }];
                }
                if (currency === 'centeral_euro_bank') {
                    return [{
                        "label": chartData.centeral_euro_bank.label,
                        "data": chartData.centeral_euro_bank.data,
                        "category": chartData.centeral_euro_bank.category,
                        "fill": false,
                        "borderColor": "#0082FF",
                        "backgroundColor": "#0082FF55",
                        "lineTension": 0.1
                    }]
                }
                if (currency === 'euro') {
                    return [{
                        "label": chartData.euro.label,
                        "data": chartData.euro.data,
                        "category": chartData.euro.category,
                        "fill": false,
                        "borderColor": "#0082FF",
                        "backgroundColor": "#0082FF55",
                        "lineTension": 0.1
                    }]
                }
                if (currency === 'euro_bank') {
                    return [{
                        "label": chartData.euro_alternate.label,
                        "data": chartData.euro_alternate.data,
                        "category": chartData.euro_alternate.category,
                        "fill": false,
                        "borderColor": "#0082FF",
                        "backgroundColor": "#0082FF55",
                        "lineTension": 0.1
                    }]
                }
                if (currency === 'centeral_aed_bank') {
                    return [{
                        "label": chartData.centeral_aed_bank.label,
                        "data": chartData.centeral_aed_bank.data,
                        "category": chartData.centeral_aed_bank.category,
                        "fill": false,
                        "borderColor": "#FFC400",
                        "backgroundColor": "#FFC40055",
                        "lineTension": 0.1
                    }]
                }
                if (currency === 'aed') {
                    return [{
                        "label": chartData.aed.label,
                        "data": chartData.aed.data,
                        "category": chartData.aed.category,
                        "fill": false,
                        "borderColor": "#FFC400",
                        "backgroundColor": "#FFC40055",
                        "lineTension": 0.1
                    }]
                }
                if (currency === 'aed_bank') {
                    return [{
                        "label": chartData.aed_alternate.label,
                        "data": chartData.aed_alternate.data,
                        "category": chartData.aed_alternate.category,
                        "fill": false,
                        "borderColor": "#FFC400",
                        "backgroundColor": "#FFC40055",
                        "lineTension": 0.1
                    }]
                }
            }
        })
    }
}

function loadCharts() {
    const ctx = document.querySelector('#myCharts');
    if (ctx !== null) {
        import ('../src/script/chartjs/chart.min.js').then(Chart => {
            var datasets = [];
            for (const [key, value] of Object.entries(chartData)) {
                if (key != "labels" && key != "categories" && value.label != undefined) {
                    datasets.push({
                        "label": value.label,
                        "data": value.data,
                        "fill": true,
                        "borderColor": "#92D6E9",
                        "backgroundColor": "#4AA6DF55",
                        "lineTension": 0.1,
                    });
                }
            }
            var myChart = new Chart(ctx, {
                "type": "line",
                "data": {
                    "labels": chartData.labels,
                    "datasets": datasets
                }
            });
        })
    }
}

function loadChat() {
    var chat = document.querySelector('#chat');
    if (chat) {
        import ('../src/script/components/chat.js').then(chat => {
            console.log(chat);
            chat.init();
        })
    }
}

if ('serviceWorker' in navigator) {
    // public/v3/dist/browserModern/sw.js
    const sw = `${BASE.url}/v3/dist/browserModern/sw.js`; // it is needed because parcel will not recognize this as a file and not precess in its manner
    navigator.serviceWorker
        .register(sw)
        .then(registration => {
            registration.onupdatefound = () => {
                const installingWorker = registration.installing;
                if (installingWorker == null) {
                    return;
                }
                installingWorker.onstatechange = () => {
                    if (installingWorker.state === "installed") {
                        if (navigator.serviceWorker.controller) {
                            console.log(
                                "New content is available and will be used when all " +
                                "tabs for this page are closed. See https://bit.ly/CRA-PWA."
                            );
                        } else {
                            console.log("Content is cached for offline use.");
                        }
                    }
                };
            };
        })
        .catch(error => {
            console.error("Error during service worker registration:", error);
        });
}

function checkSurvey() {
    setTimeout(() => {
        const survey = document.querySelector('#survey-message');
        if (survey) {
            const isTouched = localStorage.getItem('survey_touched');
            if (!isTouched) {
                survey.classList.add('open');
            }
        }
    }, 1000)
}